import initPubSub from './pubsub/index';

initPubSub();
